// extracted by mini-css-extract-plugin
export default {"availableItems":"styles-module__availableItems__src-labstep-web-components-Resource-Preview-Card-_QEolL"};